/**
 * Os avisos do topo da seção de candidatas sobre a leitura proposta das imagens de documento.
 *
 * - **Em curso** (E114.F3.C02, F-E114.F3-04): a leitura roda em segundo plano e a tela espera.
 * - **Pendentes** (E118.F1, GUS-127): quantas leituras não foram confirmadas nem corroboradas pelo
 *   cadastro — os dados delas não entram no documento. Sem trava (decisão do owner, 28/09).
 */
import { ptBR } from '@/i18n/pt-BR';
import { leituraPendente, type CandidatasDoCasoData } from '@/lib/candidatas_de_imagem';

const t = ptBR.analiseFotografica.candidatas.leitura;

/** E118.F1 (GUS-127): quantas leituras propostas aguardam confirmação, no topo das candidatas. */
export function LeiturasPendentes({
  leituras,
}: {
  leituras: CandidatasDoCasoData | null;
}): JSX.Element | null {
  const n = (leituras?.leituras ?? []).filter(leituraPendente).length;
  if (n === 0) return null;
  return (
    <p role="status" className="text-body-sm text-fg" data-testid="leituras-pendentes">
      {n === 1 ? t.pendentesContadorUm : t.pendentesContador.replace('{n}', String(n))}
    </p>
  );
}

/** E114.F3.C02 (F-E114.F3-04): a leitura proposta ainda roda em segundo plano — a tela espera. */
export function LeituraEmCurso({ emCurso }: { emCurso: number }): JSX.Element | null {
  if (emCurso === 0) return null;
  return (
    <p role="status" className="text-body-sm text-fg-muted" data-testid="leitura-em-curso">
      {t.emCurso}
    </p>
  );
}
